// Dependecies
import { createStore, createHook } from 'react-sweet-state';

const initialState = {
  maintenancesResponse: [],
  successfully: false,
};

const actions = {
  setMaintenances:
    (token, data, locale) =>
      ({ getState, setState }) =>
        new Promise(async (resolve, reject) => {
          try {
            const options = {
              method: 'POST',
              body: JSON.stringify(data),
              headers: {
                'Content-Type': 'application/json',
                Authorization: `bearer ${token}`,
              },
            };
            const response = await fetch(
              `/api/bread/jwt/garage_workshops/static/maintenance?lang=${locale}`,
              options
            );

            const newMaintenance = await response.json();
            if (response.status === 200) {
              setState({ maintenancesResponse: newMaintenance });
              resolve(getState().maintenancesResponse);
            }

            if (response.status === 401) {
              reject(response);
            }
          } catch (e) {
            reject(e);
          }
        }),
  setMaintenancesCompany:
    (token, data, locale) =>
      ({ getState, setState }) =>
        new Promise(async (resolve, reject) => {
          try {
            const options = {
              method: 'POST',
              body: JSON.stringify(data),
              headers: {
                'Content-Type': 'application/json',
                Authorization: `bearer ${token}`,
              },
            };
            const response = await fetch(
              `/api/bread/jwt/vehicles/static/maintenance?lang=${locale}`,
              options
            );

            const newMaintenance = await response.json();
            if (response.status === 200) {
              setState({ maintenancesResponse: newMaintenance });
              resolve(getState().maintenancesResponse);
            }

            if (response.status === 401) {
              reject(response);
            }
          } catch (e) {
            reject(e);
          }
        }),
  setQualityService:
    (token, data, locale) =>
      ({ getState, setState }) =>
        new Promise(async (resolve, reject) => {
          try {
            const options = {
              method: 'POST',
              body: JSON.stringify(data),
              headers: {
                'Content-Type': 'application/json',
                Authorization: `bearer ${token}`,
              },
            };
            const response = await fetch(
              `/api/bread/jwt/vehicles/static/quality_service?lang=${locale}`,
              options
            );

            const res = await response.json();
            if (response.status === 200) {
              setState({ maintenancesResponse: res });
              resolve(getState().maintenancesResponse);
            }

            if (response.status === 401) {
              reject(response);
            }
          } catch (e) {
            reject(e);
          }
        }),
  update:
    (token, data) =>
      ({ getState, setState }) =>
        new Promise(async (resolve, reject) => {

          try {
          
            const options = {
              method: 'POST',
              body: JSON.stringify(data),
              headers: {
                'Content-Type': 'application/json',
                Authorization: `bearer ${token}`,
              },
            };
            const response = await fetch('/api/bread/jwt/services/static/update_service', options);
            const updateMaintenance = await response.json();

            if (response.status === 200) {
              setState({ response: updateMaintenance });
              resolve(getState().response);
            }

            if (response.status === 401) {
              reject(response);
            }
          } catch (e) {
            reject(e);
          }
        }),
  filter:
    (token, data) =>
      ({ getState, setState }) =>
        new Promise(async (resolve, reject) => {
          try {
            const options = {
              method: 'POST',
              body: JSON.stringify(data),
              headers: {
                'Content-Type': 'application/json',
                Authorization: `bearer ${token}`,
              },
            };
            const response = await fetch('/api/bread/jwt/services/static/filter_service', options);
            const maintenance = await response.json();
            if (response.status === 200) {
              setState({ response: maintenance });
              resolve(getState().response);
            }

            if (response.status === 401) {
              reject(response);
            }
          } catch (e) {
            reject(e);
          }
        }),
  insertImage:
    (token, data, id = null) =>
      ({ getState, setState }) =>
        new Promise(async (resolve, reject) => {
          try {
            const formData = new FormData();
            const idService = data.idService;

            formData.append('idService', idService);
            formData.append('id', id);
            formData.append('valideFile', idService?false:true);
            
            // Agregar los archivos al FormData
            if(idService){
              if (data.dataInApproval[`images1_${idService}`] && Array.isArray(data.dataInApproval[`images1_${idService}`])) {
                data.dataInApproval[`images1_${idService}`].forEach((file, index) => {
                  if (file instanceof File) {
                    formData.append(`images1[${index}]`, file); // Agregar imagen a FormData
                  }
                });
              }
  
              if (data.dataInApproval[`images2_${idService}`] && Array.isArray(data.dataInApproval[`images2_${idService}`])) {
                data.dataInApproval[`images2_${idService}`].forEach((file, index) => {
                  if (file instanceof File) {
                    formData.append(`images2[${index}]`, file); // Agregar imagen a FormData
                  }
                });
              }
            }
          

            if (data.file && Array.isArray(data.file)) {
              data.file.forEach((file, index) => {
                if (file instanceof File) {
                  formData.append(`file[${index}]`, file); // Agregar imagen a FormData
                }
              });
            }
            const options = {
              method: 'POST',
              body: formData,
              headers: {
                Authorization: `bearer ${token}`,
              },
            };
            const response = await fetch('/api/bread/jwt/services/static/insert_image_in_approved', options);
            const images = await response.json();
            if (response.status === 200) {
              setState({ response: images.original.files });
              resolve(getState().response);
            }

            if (response.status === 401 || response.status === 500) {
              reject(response);
            }
          } catch (e) {
            reject(e);
          }
        }),
  requestAdditionalApproval:
    (token, data) =>
      ({ getState, setState }) =>
        new Promise(async (resolve, reject) => {
          try {
            const options = {
              method: 'POST',
              body: JSON.stringify(data),
              headers: {
                'Content-Type': 'application/json',
                Authorization: `bearer ${token}`,
              },
            };
            const response = await fetch('/api/bread/jwt/services/static/request_additional_approval', options);
            const result = await response.json();

            if (response.status === 200) {
              setState({ response: result });
              resolve(getState().response);
            }

            if (response.status === 401 || response.status === 422 || response.status === 500) {
              reject(result);
            }
          } catch (e) {
            reject(e);
          }
        }),
};

const Store = createStore({
  initialState,
  actions,
  name: 'maintenances',
});

export default createHook(Store);
